import { Skeleton } from "components/ui/skeleton";

const SKELETON_FIELD_COUNT = 4;

// Mirrors PanelSection and PanelField — a title row, then per item a short label
// above a taller value — so the rail does not reflow when the real section arrives.
export const PanelSectionSkeleton = ({ titled = true }) => (
  <div
    aria-busy="true"
    aria-label="Loading section"
    className="tw:flex tw:flex-col tw:gap-2 tw:border-t tw:border-sidebar-border tw:pt-3 tw:first:border-t-0 tw:first:pt-0"
  >
    {titled && (
      <div aria-hidden className="tw:flex tw:h-4 tw:items-center">
        <Skeleton className="tw:h-3 tw:w-24" />
      </div>
    )}
    {Array.from({ length: SKELETON_FIELD_COUNT }, (_, index) => (
      <div key={index} aria-hidden className="tw:flex tw:flex-col tw:gap-0.5">
        <div className="tw:flex tw:h-4 tw:items-center">
          <Skeleton className="tw:h-3 tw:w-16" />
        </div>
        <Skeleton className="tw:h-4 tw:w-36" />
      </div>
    ))}
  </div>
);
